import { ObjectId } from 'lib_ui-services';

export default {
    verb: 'didCreate',
    namespace: 'metaui',
    relation: 'useCase',
    description: 'Create the initial editable version for a new functional module',
    logic: didCreate
};

async function didCreate({ data, dispatch }) {
    const { _id, title, isModule } = data.newRecord;
    await dispatch(
        {
            initialVersion: true,
            newRecord: {
                _id: ObjectId(),
                title: `${title} v0.0.0`,
                isModule,
                'metaui:useCase': { _id, title },
                major: 0,
                minor: 0,
                patch: 0,
                build: 0,
                version: '0.0.0.0',
                locked: false,
                verified: false,
                notes: ''
            }
        },
        { verb: 'create', namespace: 'metadata', relation: 'useCaseDetail' },
        true
    );
}
